import React from "react";
import { Download } from "lucide-react";
import { API_URL, getToken } from "@/lib/api";

/**
 * Tombol Download Excel backup — konsisten di semua menu Kepsek.
 * Otomatis menyisipkan token `?auth=` dan query filter yang sedang diterapkan.
 * @param {string} endpoint  Nama endpoint tanpa prefix, contoh "siswa"
 * @param {object} filters   Nilai filter yang SUDAH diterapkan (bukan pending)
 */
export default function BackupExcelButton({ endpoint, filters = {}, label = "Download Excel", testId }) {
  const token = getToken();
  const qs = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, String(v));
  });
  if (token) qs.append("auth", token);
  const q = qs.toString();
  const href = `${API_URL}/backup/${endpoint}${q ? `?${q}` : ""}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="pp-btn-secondary text-emerald-700 border-emerald-200 hover:bg-emerald-50"
      data-testid={testId || `backup-${endpoint}`}
      title="Download backup Excel sesuai filter yang diterapkan"
    >
      <Download className="w-4 h-4" /> {label}
    </a>
  );
}
